module.exports = __webpack_public_path__ + "static/img/WxH.86f7269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/WxH.png
// module id = RipU
// module chunks = 83